import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    useSsSelector as useSelector,
} from '~SpectateStore';

import { AnimatePresence, motion } from 'framer-motion';

import {
    selectUiMode,
    selectIsFullScreen,
    selectDisplayFullslip,
    selectDisplayBabyslip,
} from '~Betslip/selectors/uiSelectors';

import { useBetslipAnimationEnabled } from '~SpectateStore/hooks/clientStateHooks';

import Babyslip from '../Baby';
import Fullslip from '../Full';

const BABY = 'baby';
const FULL = 'full';

const AnimatedBetslip = ({ animate, mode }) => {
    const component = mode === BABY
        ? <Babyslip />
        : <Fullslip />;

    if (!animate) {
        return <>{component}</>;
    }

    const transitions = {
        [BABY]: {
            type: 'spring',
            damping: 90,
            stiffness: 780,
        },
        [FULL]: {
            type: 'spring',
            damping: 90,
            stiffness: 980,
        },
    };

    const variants = {
        hidden: { y: '100%' },
        visible: { y: '0%' },
        exit: { y: '100%' },
    };

    const style = mode === BABY
        ? { position: 'absolute', bottom: 0, width: '100%' }
        : null;

    const transition = transitions[mode];

    return (
        <motion.div
            transition={transition}
            variants={variants}
            style={style}
            initial="hidden"
            animate="visible"
            exit="exit"
        >
            {component}
        </motion.div>
    );
};

const Betslip = () => {
    const uiMode = useSelector(selectUiMode);
    const isFullScreen = useSelector(selectIsFullScreen);
    const isAnimationEnabled = useBetslipAnimationEnabled();
    const displayBabyslip = useSelector(selectDisplayBabyslip);
    const displayFullslip = useSelector(selectDisplayFullslip);

    const betslipContainerClass = classNames(
        'betslip',
        isFullScreen ? 'betslip--fullscreen' : `betslip--${uiMode}`,
    );

    const animateBabyslip = isAnimationEnabled;
    const animateFullslip = isAnimationEnabled && uiMode !== FULL;

    return (
        <div className={betslipContainerClass}>
            <AnimatePresence>
                {displayBabyslip &&
                    <AnimatedBetslip key={BABY} mode={BABY} animate={animateBabyslip} />
                }
                {displayFullslip &&
                    <AnimatedBetslip key={FULL} mode={FULL} animate={animateFullslip} />
                }
            </AnimatePresence>
        </div>
    );
};

AnimatedBetslip.propTypes = {
    animate: PropTypes.bool.isRequired,
    mode: PropTypes.oneOf([BABY, FULL]),
};

export default Betslip;
